import request from "root/js/request";

export const getShareById = async ({ cabinet_id, shares_id }) => {
  const response = await request({
    url: `/analytics/shares/${shares_id}/?cabinet_id=${cabinet_id}`,
    method: "get",
  });
  return response;
};
